
import { Module } from "./Module";


export var chainPresets = {} 

export class Anim extends Module{

  init() {     
    if (this.data.animpreset){
      this.playPreset(this.data.animpreset,this.data.animoptions  )
    }
  }


  public playPreset(nm:string, opt:any = {}){
    var tweenOptions:any = {};
    var toNumberFields = ['duration','delay'];
    var xx,yy
    switch (nm){
      case 'popup':
        this.ref.scale = 0.4;
        this.ref.alpha = 0;
        tweenOptions.scale = 1
        tweenOptions.alpha = 1
        tweenOptions.ease = Phaser.Math.Easing.Back.Out;        
        break;
      case 'fadein':
        this.ref.alpha = 0;
        tweenOptions.alpha = 1
        tweenOptions.ease = Phaser.Math.Easing.Back.Out;        
        break;
      case 'slide_up':
        this.ref.y = 1080;       
        [xx, yy] = String(this.data.ofs).split('x')        
        tweenOptions.y = yy
        tweenOptions.ease = Phaser.Math.Easing.Back.Out;        
        break;
      case 'slide_left':
        this.ref.x = -100;       
        [xx, yy] = String(this.data.ofs).split('x')        
        tweenOptions.x = xx;
        tweenOptions.ease = Phaser.Math.Easing.Back.Out;        
        break;
      case 'slide_right':
        this.ref.x = 1920+100;       
        [xx, yy] = String(this.data.ofs).split('x')        
        tweenOptions.x = xx
        tweenOptions.ease = Phaser.Math.Easing.Back.Out;        
        break;
    }
    tweenOptions = {...tweenOptions,...opt}
    if (!tweenOptions.duration) tweenOptions.duration = 400;
    if (!tweenOptions.ease) tweenOptions.ease = 'Quad.easeInOut';

    tweenOptions.targets = this.ref;
    toNumberFields.forEach( (f)=>{
      if (tweenOptions[f]) tweenOptions[f] = Number(tweenOptions[f]) 
    })
    this.ref.scene.tweens.add(tweenOptions);
  }
}
